"use client";

import type { RoomDetailDrawerPayload } from "../room-detail-drawer-provider";

import { AccommodationBody } from "./accommodation";
import { RoomTypeBody } from "./room-type";

/**
 * Drawer の body。payload の種別 (accommodation / roomType) で fetch 経路を振り分ける。
 * hooks を条件分岐で呼ばないよう、種別ごとに別コンポーネントへ分ける。
 */
export function RoomDetailBody({
  payload,
  onCloseDrawer,
  onOpenNestedDrawer,
  onCtaMount,
}: {
  payload: RoomDetailDrawerPayload;
  onCloseDrawer: () => void;
  onOpenNestedDrawer: () => void;
  /** CTA ボタンの DOM 要素が mount/unmount したときに呼ばれる callback ref setter */
  onCtaMount: (el: HTMLButtonElement | null) => void;
}) {
  if ("roomTypeId" in payload) {
    return (
      <RoomTypeBody
        roomTypeId={payload.roomTypeId}
        onCloseDrawer={onCloseDrawer}
        reservation={payload.reservation}
      />
    );
  }
  return (
    <AccommodationBody
      payload={payload}
      onCloseDrawer={onCloseDrawer}
      onOpenNestedDrawer={onOpenNestedDrawer}
      onCtaMount={onCtaMount}
    />
  );
}
